import { useOptionalScreenClass } from 'ui/elements/ThemeProvider'
import { useMemo } from 'react'

const MobileBreakpoints = ['xs', 'sm', 'md']

export const useMobileNav = () => {
  const screenClass = useOptionalScreenClass()

  return useMemo(() => {
    if (screenClass === undefined) {
      return undefined
    }

    return MobileBreakpoints.includes(screenClass)
  }, [screenClass])
}
